<template>
    <div class="vue-vehicle-widget">
        <template v-if="loading">
            <slot></slot>
        </template>

        <template v-if="!loading && hasGroups">
            <aut-vehicle-group-slider
                v-if="vehicleGroupSlides"
                :slides="vehicleGroupSlides"
                :new-slide-id="newSlideId"
                @active-slide="handleActiveSlide"
            ></aut-vehicle-group-slider>

            <div class="container">
                <div class="row">
                    <div class="col-lg-10 mx-auto">
                        <div class="groups" :class="{'group-selected': activeSlideId}">
                            <div class="group-item" v-for="group in groups"
                                 :class="{'active': activeSlideId === group.slide_id}">
                                <button @click="handleSetVehicleGroup(group)">
                                    <aut-icon-check v-if="activeSlideId === group.slide_id"></aut-icon-check>
                                    <aut-group-icon-grabber
                                        :group-id="group.id"
                                    ></aut-group-icon-grabber>

                                    {{ group.label }}

                                    <span class="subtitle">
                                        {{ group.subtitle }}
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <div class="search-bar">
                                    <p v-if="vehicleGroup" class="mb-0 font-weight-bold">
                                        Waar wil je een
                                        <span class="color-complementary">{{ getActiveVehicleGroup.label }}</span>
                                        huren?</p>

                                    <aut-location-dropdown
                                        :vehicle-group="vehicleGroup"
                                        @active-location="handleActiveLocation"
                                        @input-value="handleInputValue"
                                    ></aut-location-dropdown>

                                    <button
                                        @click="handleClick"
                                        class="btn-primary m-0 w-100"
                                    >{{ translations.searchText }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import translations from "../mixins/translations";
import VehicleGroupSlider from "./VehicleGroupSlider.vue";
import GroupIconGrabber from "./GroupIconGrabber.vue";

export default {
    name: "VehicleWidget",

    mixins: [translations],

    props: {
        pageId: {
            required: true
        },
        isBusiness: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        'aut-vehicle-group-slider': VehicleGroupSlider,
        'aut-group-icon-grabber': GroupIconGrabber,
    },

    data() {
        return {
            vehicleGroup: null,
            vehicleGroupId: null,
            activeSlideId: null,
            activeLocation: null,
            inputValue: null,
            loading: true,
            vehicleGroupSlides: [],
            vehicleGroupNodes: [],
            newSlideId: undefined,
            groupUrl: null,
        }
    },

    computed: {
        hasActiveLocation() {
            return !lodash.isNil(this.activeLocation);
        },

        getActiveVehicleGroup() {
            return this.groups.find((item) => item.slide_id === this.activeSlideId);
        },

        getActiveVehicleGroupSlide() {
            return this.vehicleGroupSlides.find((item) => item.id === this.activeSlideId);
        },

        groups() {
            return _.map(this.vehicleGroupSlides, (slide) => {
                return {
                    id: slide.group,
                    label: slide.group_label,
                    slide_id: slide.id,
                    subtitle: slide.subtitle,
                    group_id: slide.group_id,
                }
            })
        },

        hasGroups() {
            return !_.isNil(this.groups);
        }
    },

    created() {
        this.fetchVehicleGroupNodes();
    },

    methods: {
        handleClick() {
            let url = '/autos-en-prijzen';
            const params = new URLSearchParams();

            const hasInput = !lodash.isNil(this.inputValue);
            const hasLocation = this.hasActiveLocation;
            const hasGroup = !!this.vehicleGroupId;
            const isBusiness = this.isBusiness;

            if (hasInput) {
                url = '/locaties';
                params.set('search', this.inputValue);
            }

            if (hasLocation) {
                url = this.activeLocation.url;
            }

            if (hasGroup && !hasLocation) {
                window.location = this.groupUrl;
                return;
            }

            if (!hasGroup && !hasLocation) {
                window.location = this.groupUrl;
                return;
            }

            if (isBusiness) {
                params.set('business', 'true')
            }

            if (hasGroup) {
                params.set('vehicleGroupId', this.vehicleGroupId)
            }

            const queryString = params.toString();
            window.location = queryString ? `${url}?${queryString}` : url;
        },

        handleActiveLocation(value) {
            this.activeLocation = value;

            this.handleClick();
        },

        handleInputValue(value) {
            this.inputValue = value;
        },

        fetchVehicleGroupSlides() {
            this.loading = true;

            axios.get(`/api/vehicle-group-slides/${this.pageId}`)
                .then(response => {
                    this.vehicleGroupSlides = response.data
                    this.handleSetVehicleGroup(lodash.head(this.groups))
                })
                .catch(error => this.vehicleGroupSlides = [])
                .finally(() => this.loading = false);
        },

        fetchVehicleGroupNodes() {
            this.loading = true;

            axios.get(`/api/vehicle-group-nodes`)
                .then(response => {
                    this.vehicleGroupNodes = response.data
                })
                .catch(error => this.vehicleGroupNodes = [])
                .finally(() => {
                    this.loading = false
                    this.fetchVehicleGroupSlides()
                });
        },

        handleActiveSlide(payload) {
            this.vehicleGroup = payload.group;
            this.activeSlideId = payload.id;
        },

        handleSetVehicleGroup(group) {
            this.vehicleGroupId = group.group_id;
            this.vehicleGroup = group.id;
            this.activeSlideId = group.slide_id;
            this.newSlideId = group.slide_id;

            this.groupUrl = this.vehicleGroupNodes[this.vehicleGroupId];
        },
    }
}
</script>
